<template>
  <div>
    <div class="form-group">
      <label class="control-label" for="subject-dropdown">Add Subject</label>
      <br>
      <dropdown id="subject-dropdown">
        <btn class="dropdown-toggle">Add new subject <span class="caret" /></btn>
        <template slot="dropdown">
          <li v-for="subject in filteredSubjectOptions" :key="subject">
            <a role="button" @click="addSubject(subject)">{{ subject }}</a>
          </li>
        </template>
      </dropdown>
    </div>
    <div
      class="panel panel-default"
      v-for="(sa, index) in subjectAlignments"
      :key="sa.subject">
      <div class="panel-body">
        <label :for="`domains-select-${index}`">{{ sa.subject }}</label>
        <a
          role="button"
          class="text-danger"
          :aria-label="`Remove subject ${sa.subject}`"
        >
          <i class="fa fa-times" @click="removeSubject(index)" />
        </a>
        <multi-select
          :id="`domains-select-${index}`"
          block
          v-model="sa.domains"
          :options="subjectDomainsOptionsMap[sa.subject] || []"
          placeholder="Select domains"
          @change="updateAlignments" />
      </div>
    </div>
  </div>
</template>

<script>
import { MultiSelect, Dropdown, MessageBox, Btn } from 'uiv'

export default {
  name: 'SelectSubjects',
  components: { MultiSelect, Dropdown, Btn },
  props: {
    // selections
    subjectAlignments: {
      type: Array,
      required: true,
    },

    // options
    subjects: {
      type: Array,
      default: () => [],
    },
    subjectDomainsMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      newSubject: '',
      subjectAlignmentsInternal: this.subjectAlignments || [],
    }
  },
  computed: {
    filteredSubjectOptions() {
      const selectedSubjects = this.subjectAlignments.map((sa) => sa.subject)
      return this.subjects.filter((s) => !selectedSubjects.includes(s))
    },
    subjectDomainsOptionsMap() {
      const domainsOptionsMap = {}
      Object.keys(this.subjectDomainsMap).forEach(sub => {
        domainsOptionsMap[sub] = this.subjectDomainsMap[sub]?.map(d => ({
          value: d,
          label: d,
        })) || []
      })
      return domainsOptionsMap
    },
  },
  methods: {
    addSubject(subject) {
      if (!subject || this.subjectAlignments.some(sa => sa.subject === subject)) {
        return
      }
      this.subjectAlignmentsInternal.push({
        subject: subject,
        domains: [],
      })
      this.updateAlignments()
    },
    async removeSubject(index) {
      try {
        await MessageBox.confirm({
          title: 'Remove subject',
          content: `Are you sure you want to remove ${this.subjectAlignmentsInternal[index].subject} and its domains?`
        })
        this.subjectAlignmentsInternal.splice(index, 1)
        this.updateAlignments()
      } catch {}
    },
    updateAlignments() {
      this.$emit('update:subjectAlignments', this.subjectAlignmentsInternal)
    }
  },
  watch: {
    subjectAlignments() {
      this.subjectAlignmentsInternal = this.subjectAlignments || []
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  margin-bottom: 0.5em;
}
.panel-title {
  display: block;
  &:hover {
    text-decoration: underline;
  }
}
.panel-body {
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  label {
    flex: 1 1 auto;
  }
  a[role=button] {
    margin-left: auto;
    margin-bottom: 5px;
  }

  /deep/ .btn-group {
    margin-top: 0.25em;
  }
}
</style>
